<div
    [ngClass]="{
        'tech5G': type === AD_TYPE.Tech5G,
        'filesDDD': type === AD_TYPE.FilesDDD,
        'serwis': type === AD_TYPE.Serwis,
        'new-orders': type === AD_TYPE.NewOrders,
        'img-ad': (type === AD_TYPE.VehicelesAfter2025 || type === AD_TYPE.End2gNew5g || type === AD_TYPE.Tech5gBussiness)
    }"
    class="ad-container"
>
    <div class="ad-container__left">
        <ng-container *ngIf="type === AD_TYPE.NewOrders">
            <img class="background-image new-orders-ad" src="/assets/img/new-orders-ad.png" alt="new-orders-img">
            <span class="title">Setki nowych zleceń transportowych bezpośrednio, w aplikacji z pakietem MyCar Business.</span>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.FilesDDD">
            <img class="background-image filesDDD-ad" src="/assets/img/filesDDD-ad.png" alt="filesDDD-img">
            <span class="title">
                <span class="title-custom-files">
                    <b>Maraton zgrywania plików .DDD?</b>
                </span>
                Rób to jednym kliknięciem z pakietem MyCar Business.
            </span>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.Serwis">
            <img class="background-image servis-ad" src="/assets/img/servis-ad.png" alt="servis-ad">
            <span class="title">Zatrzymaj się w porę na kolejny serwis! O żadnym nie zapomnisz z pakietem MyCar Business.</span>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.Tech5G">
            <img class="background-image tech5G-ad" src="/assets/img/tech5g.png" alt="tech5G-ad">
            <span class="title"><b>Technologia 5g już w naszych urządzeniach.</b> Zyskaj więcej możliwości z nową technologią!!</span>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.VehicelesAfter2025">
            <a href="https://5g.tekom.pl/" target="_blank">
                <img src="/assets/img/ad-vehicel-after-2025.png" alt="img">
            </a>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.End2gNew5g">
            <a href="https://5g.tekom.pl/" target="_blank">
                <img src="/assets/img/2g-end.png" alt="img">
            </a>
        </ng-container>

        <ng-container *ngIf="type === AD_TYPE.Tech5gBussiness">
            <a href="https://5g.tekom.pl/" target="_blank">
                <img src="/assets/img/5g-bussiness.png" alt="img">
            </a>
        </ng-container>
    </div>
    <a href="https://up.tekom.pl/" target="_blank" class="ad-container__submit">
        <div class="ad-container__submit__arrow">
            <i class="pi pi-angle-right"></i>
        </div>
        <span class="title">Dowiedz się więcej</span>
    </a>
</div>
